import React, { Component } from 'react';
import PhotographersComponent from '../../Components/Book/Photographers/index';
import photographers from '../../Constants/photographers';

export default class Photographers extends Component {
	render(): React.ReactElement {
		return (
			<PhotographersComponent photographers={photographers} />
		);
	}
}
